export const messages = {
  en: {
    addChainInoutOrder: {
      addTitle: 'Add Chain Inout Order',
      supplierId: 'Supplier ID',
      supplierIdPlaceholder: 'Please enter supplier ID',
      supplierIdRequired: 'Supplier ID is required',
      supplierIdMaxLength: 'Supplier ID cannot exceed 32 characters',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Chain inout order saved successfully'
    }
  },
  zh: {
    addChainInoutOrder: {
      addTitle: '添加连锁出入库单',
      supplierId: '供应商ID',
      supplierIdPlaceholder: '请输入供应商ID',
      supplierIdRequired: '供应商ID不能为空',
      supplierIdMaxLength: '供应商ID不能超过32个字符',
      cancel: '取消',
      save: '保存',
      saveSuccess: '连锁出入库单保存成功'
    }
  }
} 